import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect } from 'react';

const useBreakpointLogger = () => {
  const theme = useTheme();

  // Create media queries for breakpoints
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));
  const isXXl = useMediaQuery(theme.breakpoints.only('xxl'));

//   useEffect(() => {
//     if (isXs) {
//       console.log('Breakpoint: XS (Extra Small)');
//     } else if (isSm) {
//       console.log('Breakpoint: SM (Small)');
//     } else if (isMd) {
//       console.log('Breakpoint: MD (Medium)');
//     } else if (isLg) {
//       console.log('Breakpoint: LG (Large)');
//     } else if (isXl) {
//       console.log('Breakpoint: XL (Extra Large)');
//     } else if (isXXl) {
//         console.log('Breakpoint: XXL (Ekstra Extra Large)');
//       }
//   }, [isXs, isSm, isMd, isLg, isXl, isXXl]);
};

export default useBreakpointLogger;